import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'reactstrap';
import {
  ROUTE_CLIENT_CAMPAIGN_CREATE,
} from '../../../../config/routes';
import { history, store } from '../../../../store/store';
import { ACL } from '../../../../config/constants';
import { hideNotification } from '../../../../store/actions/notification';

function CreateCampaign() {
  if (! ACL.CLIENT.CAMPAIGNS.CREATE.hasAccess()) {
    return null;
  }

  return (
    <Fragment>
      <Button
        className="btn-warning"
        color="primary"
        onClick={() => {
         store.dispatch(hideNotification());
         history.push(ROUTE_CLIENT_CAMPAIGN_CREATE);
        }}
        size="sm"
      >
        <FormattedMessage
          id="components.pages.campaignManagement.actionButtons.create_campaign" />
      </Button>
    </Fragment>
  )
}

export { CreateCampaign };
